<template>
<div>
    <div style="width:100%;height:400px;margin-bottom:10px;">
        <div class="top_buttons">
            <el-button icon="el-icon-download" type="primary" @click="export_results('health-survey_personal_results.xlsx', 'exportJKSurveyPersonalResults')" style="width:240px;">导出组织健康度个人结果</el-button>
        </div>
        <div class="top_buttons" style="margin-top:20px;">
            <el-button icon="el-icon-download" type="primary" @click="export_results('health-survey_results.xlsx', 'exportJKSurveyResults')" style="width:240px;">导出组织健康度诊断结果</el-button>
        </div>
        <div class="top_buttons" style="margin-top:20px;">
            <el-button icon="el-icon-message" type="primary" @click="export_results('pain-spots_vote_results.xlsx', 'exportPainSpotsVoteResults')" style="width:240px;">导出管理痛点投票结果</el-button>
        </div>
        <div class="top_buttons" style="margin-top:20px;">
            <el-button icon="el-icon-setting" type="primary" @click="export_results('pain-spots_solution.xlsx', 'exportPainSpotsMgmtSolution')" style="width:240px;">导出管理痛点解决方案</el-button>
        </div>
    </div> 
</div>
</template>

<script>
import postdata from "@/api/postData.js";
export default {
    data() {
        return {
            download_file: {
                file_name: ''
            },
        };
    },
    props: ['task_id'],
    methods: {
        export_results(download_filename, api_name) {
            this.download_file.file_name = download_filename;
            let params;
            params = {
                task_id: this.task_id,
            }
            postdata.downloadFilesP(api_name, JSON.stringify(this.download_file), params)
              .then(resp => {
                this.dialogFormVisible = false;
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                if(resp.data.type=='application/json'){
                    let that = this;    //这里要用别名替代this，因为FileReader里头可能也用到了this，两边有冲突
                    const reader  = new FileReader();  //创建一个FileReader实例
                    reader.readAsText(resp.data, 'utf-8'); //读取文件,结果用字符串形式表示
                    reader.onload=function(){   //读取完成后,**获取reader.result**
                        const msg = JSON.parse(reader.result);
                        that.$message({
                        message: msg.message,
                        type: 'error',
                        duration: 6000,
                        // showClose: true,
                        })
                    }
                }else{
                this.download(resp);
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        },
    }
}
</script>

<style scoped>
.top_buttons > .el-button {
    font-size: 16px;
}
</style>

